import { useState } from 'react';
import AppointmentRow from './AppointmentRow';
import CheckoutSheet from './CheckoutSheet';

// Checkout: arrived guests ready to settle, plus recently completed.
const CheckoutList = ({ ready, completed, currency, onCompletePayment }) => {
  const [selected, setSelected] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleComplete = async (payload) => {
    if (!selected || submitting) return;
    setSubmitting(true);
    await onCompletePayment?.(selected.id, payload);
    setSubmitting(false);
    setSelected(null);
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-light text-ink-900">Checkout</h2>
        <p className="mt-1 text-sm text-ink-700/80">
          Complete visits once the service is done. Totals feed into today&rsquo;s till.
        </p>
      </div>

      <section>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-ink-600/60">
          Ready to checkout · {ready.length}
        </p>
        {ready.length === 0 ? (
          <div className="bg-sand-50 px-5 py-10 text-center ring-1 ring-ink-900/10">
            <p className="text-sm text-ink-700/70">No one waiting to settle right now.</p>
          </div>
        ) : (
          <div className="bg-sand-50 ring-1 ring-ink-900/10">
            <ul className="divide-y divide-ink-900/10">
              {ready.map((appt) => (
                <AppointmentRow
                  key={appt.id}
                  appointment={appt}
                  currency={currency}
                  actions={[
                    {
                      id: 'checkout',
                      label: 'Checkout',
                      primary: true,
                      onClick: () => setSelected(appt),
                    },
                  ]}
                />
              ))}
            </ul>
          </div>
        )}
      </section>

      <section>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-ink-600/60">
          Completed today · {completed.length}
        </p>
        {completed.length === 0 ? (
          <div className="bg-sand-50 px-5 py-10 text-center ring-1 ring-ink-900/10">
            <p className="text-sm text-ink-700/70">Completed checkouts will show here.</p>
          </div>
        ) : (
          <div className="bg-sand-50 ring-1 ring-ink-900/10">
            <ul className="divide-y divide-ink-900/10">
              {completed.map((appt) => (
                <AppointmentRow key={appt.id} appointment={appt} currency={currency} />
              ))}
            </ul>
          </div>
        )}
      </section>

      {selected && (
        <CheckoutSheet
          appointment={selected}
          currency={currency}
          submitting={submitting}
          onClose={() => (submitting ? null : setSelected(null))}
          onComplete={handleComplete}
        />
      )}
    </div>
  );
};

export default CheckoutList;
